import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import {
  Grid,
  Accordion as MuiAccordion,
  AccordionSummary as MuiAccordionSummary,
  AccordionDetails as MuiAccordionDetails,
  withStyles
} from '@material-ui/core'

import { toGermanFormat } from '../../../../../../../../utils/numberFormater'

import useStyles from './styles'

const Accordion = withStyles({
  root: {
    border: 'none',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: '#EEF0F2',
    borderBottom: '1px solid #D9DCDF',
    minHeight: 41,
    '&$expanded': {
      minHeight: 41,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: 0,
  },
}))(MuiAccordionDetails);

function ExAnteSection(props) {

  const {
    title,
    euroValue,
    percentValue,
    children
  } = props;

  const classes = useStyles();

  return (
    <Accordion square expanded>
      <AccordionSummary>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <span className={classes.label}>
              { title }
            </span>
          </Grid>
          <Grid item xs={3}>
            <span className={clsx(classes.label, classes.alignRight)}>
              { (percentValue || percentValue === 0) ? toGermanFormat(percentValue * 100, undefined, ' %') : '' }
            </span>
          </Grid>
          <Grid item xs={3}>
            <span className={clsx(classes.label, classes.alignRight)}>
              { (euroValue || euroValue === 0) ? toGermanFormat(euroValue, undefined, ' €') : '' }
            </span>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container>
          { children }
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
}

ExAnteSection.propTypes = {

  /** Section title */
  title: PropTypes.string.isRequired,

  /** Value in EUR */
  euroValue: PropTypes.number.isRequired,

  /** Value in % */
  percentValue: PropTypes.number.isRequired,
};


export default ExAnteSection

